import {
  IAggregationQuery,
  ICollectionSchemaResponse,
  IListCollectionResponse,
} from "../types";
import VectorAIBase from "./vectorai-base.service";

class VectorAIService extends VectorAIBase {
  public async listCollections() {
    return await this.get<IListCollectionResponse>("/project/list_collections");
  }

  public async randomAggregationQuery(
    collectionSchema: ICollectionSchemaResponse,
    groupby: number = 1,
    metrics: number = 1
  ): Promise<IAggregationQuery> {
    const fullAggregationQuery: IAggregationQuery = {
      groupby: [],
      metrics: [],
    };

    Object.keys(collectionSchema).forEach((key) => {
      if (collectionSchema[key] === "text") {
        fullAggregationQuery["groupby"].push({
          name: key,
          agg: "texts",
          field: key,
        });
      } else if (collectionSchema[key] === "numeric") {
        fullAggregationQuery["metrics"].push({
          name: key,
          agg: "avg",
          field: key,
        });
      }
    });

    return {
      groupby: fullAggregationQuery.groupby
        .sort(() => Math.random() - Math.random())
        .slice(0, groupby),
      metrics: fullAggregationQuery.metrics
        .sort(() => Math.random() - Math.random())
        .slice(0, metrics),
    };
  }
}

export default new VectorAIService();
